import React from 'react';
import { getFormattedAmount } from 'src/shared/utils/src';

type AmountProps = {
    amount: string
    currency: string
    applyFormat?: boolean
    applyColor?: boolean
    withSign?: boolean
}

const CustomAmountComponent = ({ amount, currency, applyFormat, applyColor = false, withSign = true }: AmountProps) => {

    let renderAmount = amount;
    if (applyFormat) {
        renderAmount = getFormattedAmount(amount, currency, withSign);
    }

    const isNegative = amount?.toString()?.startsWith('-');

    const colorStyle = (applyColor && Number(amount) !== 0) ? (
        (isNegative ? 'status-red' : 'status-green')
    ) : '';

    return (
        <p className={colorStyle}>{renderAmount}</p>
    );
}

export default CustomAmountComponent;